<div class="fn-payments">  
  <div class="fn-payments__table">
    <app-fn-payments-done></app-fn-payments-done>
  </div>
</div>
